rjm.model.Client = Backbone.Model.extend({
	initialize: function(options) {
		if (!options || !options.id)
			throw "InvalidConstructorArgs - Client";

		this.clientId = options.id;
	},
	url : function() {
		return $.url('/client/'+this.clientId);
	}
});

rjm.model.ClientCollection = Backbone.Collection.extend({
	initialize: function(models, options) {
		if (!options || !options.client)
			throw "InvalidConstructorArgs - Client Collection";
		this.client = options.client;
	}
});